import Axios from "../../configs/axios.config";

export const createJobopening = (data) => Axios.post(`/recruitment/job-opening`, data).then(response => response.data);
export const updateJobopening = (data, id) => Axios.put(`/recruitment/job-opening/${id}`, data).then(response => response.data);
export const getJobopeningList = (data) => Axios.get('/recruitment/job-opening', { params: data }).then(response => response.data);
export const getJobopeningDetail = (id, data) => Axios.get(`/recruitment/job-opening/${id}`, { params: data }).then(response => response.data);
export const deleteJobopening = (id) => Axios.delete(`/recruitment/job-opening/${id}`);



export const getJobopeningDetailOpen = (id, data) => Axios.get(`/recruitment/apply/job-opening/${id}`, { params: data }).then(response => response.data);

// Job Application
export const createJobApplication = (data) => Axios.post(`/recruitment/job-application`, data).then(response => response.data);
export const updateJobApplication = (data, id) => Axios.put(`/recruitment/job-application/${id}`, data).then(response => response.data);
export const getJobApplicationList = (data) => Axios.get('/recruitment/job-application', { params: data }).then(response => response.data);
export const getJobApplicationDetail = (id, data) => Axios.get(`/recruitment/job-application/${id}`, { params: data }).then(response => response.data);
export const deleteJobApplication = (id) => Axios.delete(`/recruitment/job-application/${id}`);



export const updateJobApplicationBulk = (data, id) => Axios.put(`/recruitment/job-application/update-multiple`, data).then(response => response.data);
export const scheduleInterview = (data) => Axios.post(`/recruitment/job-interview`, data).then(response => response.data);
export const scheduleInterviewList = (data) => Axios.get(`/recruitment/job-interview`, { params: data }).then(response => response.data);
